import React from 'react';
import LinkLines from './component';

export default React.memo(LinkLines);
